<template>
    <span class="image-preview-pic-container">
        <a v-if="type === 'url'" class="image-preview-dom" :class="{ 'invalid': urlError }" href="javascript: void(0);" @click="previewImage">{{labelText}}</a>
        <img v-if="type === 'image'" :src="url" @click="previewImage" style="height:200px; padding: 10px;width: 200px">
    </span>
</template>

<script>
    export default JBoot({
        name: 'imagePreviewPicSmall',

        componentName: 'imagePreviewPicSmall',

        registryName: 'image-preview-pic-small',

        props: {
            //图片地址
            url: String,

            //显示的内容
            label: String,

            //是否新窗口打开
            newWindow: Boolean,

            type: {
                type: String,
                default (){
                    return "url";
                }
            }
        },

        data (){
            return {
                urlError: true
            }
        },

        computed: {
            labelText (){
                return this.urlError ? '无效的图片链接' : ( this.label || this.url );
            }
        },

        methods: {
            //检测地址是否合法
            checkImgUrl (){
                let img = document.createElement('img');
                img.onload = function () {
                    this.urlError = false;
                    this.imgDom = img;
                }.bind(this);
                img.src = this.url;
            },

            //预览图片
            previewImage (){
                if(this.urlError) return;

                if(this.newWindow){
                    window.open(this.url, '_blank');
                }else{
                    if(!this.imgDom){
                        this.imgDom = document.createElement('img');
                        this.imgDom.src = this.url;
                    }
                    this.showPreviewMask().appendChild(this.imgDom);
                }
            },

            //显图片预览遮罩
            showPreviewMask (){
                let mask = document.querySelector('[role="preview-mask"]');

                if(mask) {
                    mask.style.display = 'block';
                }else{
                    mask = document.createElement('div');

                    let close = document.createElement('div');
                    close.setAttribute('role', 'close-mask');
                    close.classList.add('image-preview-close');
                    close.innerHTML = 'X';

                    mask.appendChild(close);

                    document.body.appendChild(mask);
                }

                mask.setAttribute('role', 'preview-mask');
                mask.classList.add('image-preview-mask');
                mask.addEventListener('click', function ({ target, currentTarget }) {
                    if(!currentTarget || !['preview-mask', 'close-mask'].includes(target.getAttribute('role'))){
                        return;
                    }

                    currentTarget.style.display = 'none';
                    currentTarget.children && Array.from(currentTarget.children).filter(child => child.getAttribute('role') !== 'close-mask').forEach(child => currentTarget.removeChild(child));
                }.bind(this));

                return mask;
            }
        },

        watch: {
            url: {
                immediate: true,
                handler (v, o){
                    this.checkImgUrl();
                }
            }
        }
    }).build();
</script>

<style lang="scss">
    .image-preview-pic-container{
        & > .image-preview-dom{
            &.invalid{
                cursor: not-allowed;
                color: #ec407a;
            }
        }
    }
    .image-preview-mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(158, 158, 158, 0.85);
        z-index: 99999;
        & > .image-preview-close{
            position: fixed;
            right: 10px;
            top: 10px;
            width: 40px;
            height: 40px;
            font-size: 20px;
            text-align: center;
            line-height: 40px;
            background-color: #333333a3;
            color: #ffffff;
            border-radius: 50%;
            cursor: pointer;
            &:hover{
                background-color: #000000;
            }
        }
        & > img{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            /*max-width: 1000px;*/
            max-height: 400px;
            max-width: calc(100% - 15px);
            /*max-height: 100%;*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageProvewPic2.vue